import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const AvatarHead = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M7.0212766,9.78723404 C7.84382835,9.78723404 8.5106383,10.454044 8.5106383,11.2765957 C8.5106383,12.0991475 7.84382835,12.7659574 7.0212766,12.7659574 C6.19872484,12.7659574 5.53191489,12.0991475 5.53191489,11.2765957 C5.53191489,10.454044 6.19872484,9.78723404 7.0212766,9.78723404 Z M12.9787234,9.78723404 C13.8012752,9.78723404 14.4680851,10.454044 14.4680851,11.2765957 C14.4680851,12.0991475 13.8012752,12.7659574 12.9787234,12.7659574 C12.1561716,12.7659574 11.4893617,12.0991475 11.4893617,11.2765957 C11.4893617,10.454044 12.1561716,9.78723404 12.9787234,9.78723404 Z M10,17.8723404 C5.65531915,17.8723404 2.12765957,14.3493617 2.12765957,10 C2.12765957,9.49787234 2.17446809,9.00851064 2.26808511,8.53659574 C4.56170213,7.7787234 6.39191489,5.98723404 7.20425532,3.71489362 C8.49361702,6.30638298 11.1702128,8.08510638 14.2553191,8.08510638 C15.387234,8.08510638 16.4638298,7.84680851 17.4382979,7.41744681 C17.7191489,8.22553191 17.8723404,9.09361702 17.8723404,10 C17.8723404,14.3493617 14.3489362,17.8723404 10,17.8723404 Z M19.2765957,6.27234043 C17.8042553,2.59617021 14.2042553,0 10,0 C9.1787234,0 8.38297872,0.0978723404 7.6212766,0.289361702 C7.2,0.387234043 6.79148936,0.514893617 6.39574468,0.676595745 C2.97446809,1.99574468 0.459574468,5.1493617 0.0553191489,8.93191489 C0.0212765957,9.2812766 0,9.63829787 0,10 C0,15.5234043 4.48085106,20 10,20 C15.5234043,20 20,15.5234043 20,10 C20,8.68085106 19.7446809,7.4212766 19.2765957,6.27234043 Z"
				id="avatarHead"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

AvatarHead.propTypes = {
	color: PropTypes.string,
};

export default AvatarHead;
